module.exports = __webpack_public_path__ + "img/891eb099110aca67720a06b13ac98373a6537dee.aba8bbb5.png";